export enum SANDBOX_ROUTES {
  MAIN = '',
  TRACKING = 'tracking',
  USER_MAPPING = 'user-mapping',
  COMPLETE = 'complete'
}
